import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-performance-dashboard',
  	templateUrl: './toolcards-performance-dashboard.component.html',
  	styleUrls: ['./toolcards-performance-dashboard.component.scss']
})
export class ToolcardsPerformanceDashboardComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
